import Services from "../../../jsx/components/Dashboard/Services/services";

const ServicesWrapper = () => {
  return <Services />;
};

export default constore(ServicesWrapper);
